import {
  TOGGLE_EDIT_BATCH_ORDER_MODAL,
  TOGGLE_BATCH_INVOICE_BUTTON_ENABLED,
  SET_LAST_LOAD_BATCH_ORDERS_PARAMS,
  SET_BATCH_PAYMENT_PROCESSING,
} from '@actions/ui/batchOrderPage'

const initialState = {
  on: true,
  page: undefined,
  search: undefined,
  status: undefined,
  processing: false,
}
const initialEditBatchOrderModalState = { show: false, mode: 'edit' }

export const batchOrderPage = (state = initialState, action) => {
  switch (action.type) {
    case TOGGLE_BATCH_INVOICE_BUTTON_ENABLED:
      return {
        ...state,
        on: action.on,
      }
    case SET_LAST_LOAD_BATCH_ORDERS_PARAMS: {
      const { page, search, status } = action

      return {
        ...state,
        page,
        search,
        status,
      }
    }
    case SET_BATCH_PAYMENT_PROCESSING: {
      return {
        ...state,
        processing: action.processing,
      }
    }
    default:
      return state
  }
}

export const editBatchOrderModal = (
  state = initialEditBatchOrderModalState,
  action,
) => {
  switch (action.type) {
    case TOGGLE_EDIT_BATCH_ORDER_MODAL: {
      const { show, mode = state.mode } = action

      return { show, mode }
    }
    default:
      return state
  }
}
